import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import QuotationEditClient from "@/components/quotations/quotation-edit-client";
import { Doc } from "@/convex/_generated/dataModel";

export const Route = createFileRoute(
  "/_authenticated/quotations/$code/edit",
)({
  validateSearch: (search: Record<string, unknown>) => ({
    /**
     * Activa el modo CRDT en el form. Default false. Ver
     * docs/plan-crdt-phase-3-quotation-form.md.
     *
     * Acepta "1" y 1 — usamos números en vez de booleanos porque TanStack
     * Router descarta los booleanos puros en `navigate({ search: ... })`
     * durante el round-trip parseSearch/validateSearch (observado en AC4).
     */
    crdt:
      search.crdt === "1" ||
      search.crdt === "true" ||
      search.crdt === 1 ||
      search.crdt === true
        ? 1
        : 0,
    /**
     * BETA: si está activo, fuerza que los pushes al server fallen con un error
     * simulado. Sirve para testear el flujo offline (AC4) sin cortar la red
     * real. Ver docs/plan-crdt-phase-3-quotation-form.md sección 9.
     *
     * Mismo motivo que `crdt`: usamos 1/0 en lugar de booleanos.
     */
    "crdt-offline":
      search["crdt-offline"] === "1" ||
      search["crdt-offline"] === "true" ||
      search["crdt-offline"] === 1 ||
      search["crdt-offline"] === true
        ? 1
        : 0,
  }),
  component: QuotationEditPage,
});

function QuotationEditPage() {
  const { code } = Route.useParams();
  const { crdt, "crdt-offline": crdtOffline } = Route.useSearch();
  const isCrdt = !!crdt;
  const isOffline = !!crdtOffline;

  return (
    <RouteGuardPermissions
      permissions={[{ module: "quotations", actions: ["read", "update"] }]}
    >
      <QuotationEditClient
        code={code as Doc<"quotations">["code"]}
        mode={isCrdt ? "crdt" : "legacy"}
        forceOffline={isOffline}
      />
    </RouteGuardPermissions>
  );
}
